import type {
  ListOrderOptions,
  ListSortOptions,
} from '@/modules/chatting/types'

import type { CollectionsItem } from './CollectionsList/types'

export const sortDefaultLists = (
  lists: CollectionsItem[],
  sort: ListSortOptions,
  order: ListOrderOptions,
) => {
  return lists.sort((a, b) => {
    if (sort === 'name') {
      return order === 'asc'
        ? a.name.localeCompare(b.name)
        : b.name.localeCompare(a.name)
    }

    if (sort === 'people') {
      return order === 'asc'
        ? a.usersCount - b.usersCount
        : b.usersCount - a.usersCount
    }

    return 0
  })
}
